import { render, staticRenderFns } from "./SoDetail.vue?vue&type=template&id=4bcc1ab3"
import script from "./SoDetail.vue?vue&type=script&lang=js"
export * from "./SoDetail.vue?vue&type=script&lang=js"
import style0 from "./SoDetail.vue?vue&type=style&index=0&id=4bcc1ab3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports